import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    
    // If it's an authentication-related error, clear localStorage
    if (error.message && (
      error.message.includes('auth') || 
      error.message.includes('token') ||
      error.message.includes('user')
    )) {
      console.log('Authentication error detected, clearing localStorage...');
      localStorage.clear();
    }
  }

  handleReset = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="bg-white border border-gray-200 rounded-lg rounded-2xl p-8 max-w-md w-full text-center">
            <h2 className="text-2xl font-bold mb-4 text-red-400">Something went wrong</h2>
            <p className="text-gray-300 mb-6">
              We encountered an unexpected error. You can try refreshing the page or resetting the app.
            </p>
            <div className="space-y-3">
              <button
                onClick={() => window.location.reload()}
                className="w-full bg-white border border-gray-300 hover:bg-gray-50 py-3 px-6 rounded-xl"
              >
                Refresh Page
              </button>
              <button
                onClick={this.handleReset}
                className="w-full btn-bg-blue-500 text-white py-3 px-6 rounded-xl"
              >
                Reset App & Logout
              </button>
            </div>
            <p className="text-xs text-gray-400 mt-6">
              Tip: Press Ctrl+Shift+L (Cmd+Shift+L on Mac) to force logout anytime
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;